import { format, subMonths } from 'date-fns'
import type { AwardsEarnedTotalsResponse } from 'teacher-ui-client/utils/student-events/fetchers/awards-earned-totals'

const thisMonth = format(new Date(), 'yyyy-MM')
const lastMonth = format(subMonths(new Date(), 1), 'yyyy-MM')

export const reAwardsEarnedTotals: AwardsEarnedTotalsResponse = {
  awards_earned_totals_summary_by_grade: [
    {
      grade_position: 1,
      data: [
        { category: 'gold', count: 8 },
        { category: 'silver', count: 10 },
        { category: 'bronze', count: 1 },
      ],
    },
    {
      grade_position: 2,
      data: [
        { category: 'gold', count: 8 },
        { category: 'silver', count: 10 },
        { category: 'bronze', count: 1 },
      ],
    },
  ],

  awards_earned_totals_by_grade_by_month: [
    {
      grade_position: 1,
      months: [
        {
          gold: 3,
          silver: 1,
          bronze: 2,
          month: lastMonth,
        },
        {
          gold: 4,
          silver: 2,
          bronze: 2,
          month: thisMonth,
        },
      ],
    },
    {
      grade_position: 2,
      months: [
        {
          gold: 4,
          silver: 1,
          bronze: 1,
          month: lastMonth,
        },
        {
          gold: 1,
          silver: 2,
          bronze: 3,
          month: thisMonth,
        },
      ],
    },
  ],
}
